import slideUpLines from './animations/slide-up-lines';
import slideUpWords from './animations/slide-up-words';
import fadeInSlideUp from './animations/fade-in-slide-up';

type AnimationModule = {
  selector: string;
  init: (elements: HTMLElement[]) => void;
};

const animations: AnimationModule[] = [slideUpLines, slideUpWords, fadeInSlideUp];

const initGroup = (group: AnimationModule[]) => {
  group.forEach((animation) => {
    const elements = Array.from(document.querySelectorAll<HTMLElement>(animation.selector));
    if (elements.length === 0) {
      return;
    }
    // we want to set a data-has-animation attribute to the elements being animated
    elements.forEach((el) => {
      el.setAttribute('data-animation-state', 'queue');
    });
    animation.init(elements);
  });
};

const init = () => {
  if ('fonts' in document && document.fonts?.ready) {
    document.fonts.ready.then(() => initGroup(animations));
  } else {
    initGroup(animations);
  }
};

document.addEventListener('DOMContentLoaded', init);
